import React, { useEffect, useState } from 'react';
import { getAllAnnouncements} from '../../services/announcementsService';

import { Link } from "react-router-dom";
import "./datatable.scss"
import { DataGrid } from '@mui/x-data-grid';

export const AnnouncementList=()=> {
    const [announcements, setAnnouncements] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchAnnouncements = async () => {
        try {
            const data = await getAllAnnouncements();
          //  console.log(data);
            setAnnouncements(data.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {      

        fetchAnnouncements();
    }, []);

    const formatColumnData = (value) => {
        if (!value) return value;
    
        // Insert space before each uppercase letter
        let result = value.replace(/([a-z])([A-Z])/g, '$1 $2');
    
        // Capitalize the first letter
        result = result.charAt(0).toUpperCase() + result.slice(1);
    
        return result;
    };
    const transformColumnData = (rows) => {
        return rows.map(row => ({
            ...row,
            submissionType: formatColumnData(row.submissionType),
            announcementType: formatColumnData(row.announcementType),
            termType: formatColumnData(row.termType),
             // Only format this column
        }));
    };
    const transformedRows = transformColumnData(announcements);
    const columns = React.useMemo(
        () => [
          //  { field: 'announcementType', headerName: 'Type', width: 180 },
            { field: 'date', headerName: 'Announcement Date', width: 180 },
            { field: 'termName', headerName: 'Term', width: 180 },
            { field: 'batch', headerName: 'Batch', width: 180 },
            { field: 'submissionType', headerName: 'Report Type', width: 180 },
            { field: 'termType', headerName: 'Files Type', width: 180 },
            { field: 'submissionDeadline', headerName: 'Submission Deadline', width: 180 },
            { field: 'submissionDeadlinePptvideo', headerName: 'Presentation Deadline', width: 180 }
        ],
        []
    );

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    const actionColumn = [{ field: "action", headerName:"Action", width:200,
        renderCell:(params)=>{
            const { id } = params.row;
            return(
                <div className="cellAction">
                    <div className="viewButton"><Link to={{pathname: `/announcements/view-announcement/${id}`}} style={{textDecoration:"none"}}>View</Link></div>
                    <div className="editButton"><Link to={{pathname: `/announcements/edit-announcement/${id}`}} style={{textDecoration:"none" }}>Edit</Link></div>
                </div>
            );
        }
    }]

    return (
        <div className="datatable" >
        <div className="datatableTitle">


          <Link to="/announcements/new" className="link" >
          Add Announcement
          </Link>

        </div>
      
      <DataGrid 
      rows={transformedRows}
      columns={columns.concat(actionColumn)}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 10 },
        },
      }}
      pageSizeOptions={[5, 10]}
      //checkboxSelection
    />
  </div>
    );
}

